<template>
    <div class="content-body">
        <div class="left-list">
            <div class="left-list-title">
                <div class="color-block"></div>
                <div class="title">栏目</div>
                <div class="color-block end"></div>
            </div>
            <div class="left-list-content">
                <div class="block"></div>
                <div class="splitter"></div>
                <div class="list-content">
                    <div class="content">
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(1)">什么是温室效应</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(2)">温室效应的危害</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(3)">如何解决温室效应</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(4)">预防温室效应</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <WhatIsGreenhouseView v-if="openIndex == 1"/>
        <GreenhouseHarm v-if="openIndex == 2"/>
        <SoluteGreenhouseView v-if="openIndex == 3"/>
        <PreventGreenhouse v-if="openIndex == 4"/>
    </div>
</template>

<script>
    import WhatIsGreenhouseView from "./WhatIsGreenhouse/IndexView";
    import GreenhouseHarm from "./greenhouseHarm/IndexView";
    import SoluteGreenhouseView from "./SoluteGreenhouseView";
    import PreventGreenhouse from "./PreventGreenhouse";
    export default {
        name: "Index",
        components: {WhatIsGreenhouseView, GreenhouseHarm, SoluteGreenhouseView, PreventGreenhouse},
        data() {
            return {
                openIndex: 1
            }
        },
        methods: {
            openPage: function (index) {
                this.openIndex = index
            }
        }
    }
</script>

<style lang="scss" src="../../assets/scss/menu.scss" scoped />